import Vue from 'vue'
import CompositionApi from '@vue/composition-api'
import register from './register/'
import SharedElement from './shared-element/'
import Glass from './glass/'
import Parallax from './parallax/'
import { get } from 'lodash'
import pluralize from '@iez/lib/pluralize/'
import pluralizeMultiple from '@iez/lib/pluralize-multiple/'
import genderize from '@iez/lib/genderize'
import money from '@iez/lib/money/'
import { theme } from '@iez/core'
import $createOnClick from './create-on-click/'
import goToExternalUrl from '@iez/lib/go-to-external-url/'
Vue.use(CompositionApi)

import vuetify from './vuetify/'
import setPriority from '@iez/core/app/set-priority/'

export default ({ pages=[], layout, features=[], priorities }) => {
  /**
   * Features
   */
  Object.values(features).forEach(features => features())

  /**
   * Register pages
   */
  const router = register({ pages })
  setPriority(priorities)

  /**
   * Shared element
   */
  SharedElement.setup()

  /**
   * Glass
   */
  Glass.setup()

  /**
   * Parallax
   */
  Vue.use(Parallax)

  /**
   * Vue
   */
  Vue.prototype.$get = get
  Vue.prototype.$pluralize = pluralize
  Vue.prototype.$pluralizeMultiple = pluralizeMultiple
  Vue.prototype.$genderize = genderize
  Vue.prototype.$money = money
  Vue.prototype.$goldenRatio = 1.61803398875
  Vue.prototype.$theme = theme
  Vue.prototype.$createLengthRule = ({ max, label }) =>
    value => !value || value.length <= max || `${label} ne doit pas dépasser ${max} caractères.`
  Vue.prototype.$createOnClick = $createOnClick
  Vue.prototype.$goToExternalUrl = goToExternalUrl

  new Vue({
    router,
    vuetify,
    render: h => h(layout)
  }).$mount('#app')
}
